import React from 'react';
import { Col } from 'antd';

import Node from '../Node';

export const TwoColumns = props => (
  <React.Fragment>
    {['left', 'right'].map(pos => (
      <Col key={pos} md={12} style={{ textAlign: props.value[pos].align }}>
        <Node {...props} blocs={props.value[pos].content} span={12} />
      </Col>
    ))}
  </React.Fragment>
);

export default TwoColumns;



// WEBPACK FOOTER //
// ./src/modules/CMS/components/TwoColumns/index.js